import { render, staticRenderFns } from "./ProjectSetteiForm.vue?vue&type=template&id=2efec786&scoped=true&"
import script from "./ProjectSetteiForm.vue?vue&type=script&lang=ts&"
export * from "./ProjectSetteiForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectSetteiForm.vue?vue&type=style&index=0&id=2efec786&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efec786",
  null
  
)

export default component.exports